import React from "react"
import { Link } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import dominionLogo from "../images/footer/dominion-logo.svg"

const Footer = () => (
  <footer className="main-footer">
    <div className="main-footer__container">
      <OutboundLink
        className="main-footer__logo"
        href="https://www.dominionenergy.com/"
        target="_blank"
      >
        <img src={dominionLogo} alt="Dominion Energy" />
      </OutboundLink>
      <div className="main-footer__lists">
        <div className="list">
          <div className="list__header">BRIGHTSUITE</div>
          <div className="list__contents">
            <Link className="list__link t2" to="/overview/">
              Overview
            </Link>
            <Link className="list__link t2" to="/monitoring/">
              Monitoring Plans
            </Link>
          </div>
        </div>
        <div className="list">
          <div className="list__header">SHOP</div>
          <div className="list__contents">
            <Link className="list__link t2" to="/popular/">
              Popular Packages
            </Link>
            <Link className="list__link t2" to="/experiences/">
              Experiences
            </Link>
            <Link className="list__link t2" to="/build-your-own/">
              Build Your Own
            </Link>
            <OutboundLink className="list__link t2" href="https://shop.brightsuite.com/products">
              All Products
            </OutboundLink>
            <OutboundLink className="list__link t2" href="https://shop.brightsuite.com/packagelist">
              All Packages
            </OutboundLink>
          </div>
        </div>
        <div className="list">
          <div className="list__header">SUPPORT</div>
          <div className="list__contents">
            <Link className="list__link t2" to="/works-with/">
              Works with BrightSuite
            </Link>
            <Link
              className="list__link t2"
              to="/faq/#Contact"
            >
              Contact Us
            </Link>
            <Link className="list__link t2" to="/faq/">
              FAQ
            </Link>
            <Link className="list__link t2" to="/about/">
              About BrightSuite
            </Link>
            {/* <Link className="list__link t2" to="/solar">
              BrightSuite Solar
            </Link> */}
            <OutboundLink
              className="list__link t2"
              href="https://www.dominionenergy.com/"
              target="_blank"
            >
              Dominion Energy
            </OutboundLink>
          </div>
        </div>
      </div>
      <div className="main-footer__bottom t2">
        <div className="copyright">
          Copyright &copy; {new Date().getFullYear()} BrightSuite
        </div>
        <div className="copyright">
          DCJS #11-17252
        </div>
        {/* <OutboundLink
          className="copyright"

        >
           DCJS #11-17252
        </OutboundLink> */}
        <OutboundLink
          className="privacy"
          href="https://www.dominionenergy.com/privacy"
          target="_blank"
        >
          Privacy Policy
        </OutboundLink>
        <OutboundLink
          className="terms"
          href="https://www.dominionenergy.com/terms-and-conditions"
          target="_blank"
        >
          Terms and Conditions
        </OutboundLink>
      </div>
    </div>
  </footer>
)

export default Footer
